const { ccclass, property } = cc._decorator;
import ViewBase from "../../../../framework/core/mvvm/view_base";

@ccclass
export default class DialogTipsView extends ViewBase {
    @property(cc.Label)
    tipsLab: cc.Label = null
    @property(cc.Node)
    cancelBtn: cc.Node = null
    @property(cc.Node)
    conformBtn: cc.Node = null

    @property([cc.Node])
    titileStyle : cc.Node[] = [];

    private maxNumb:number = 666

    showTips(str: string) {
        this.tipsLab.string = str
        this.tipsLab.overflow = cc.Label.Overflow.NONE;
        this.tipsLab.horizontalAlign = cc.Label.HorizontalAlign.CENTER;
        //@ts-ignore
        this.tipsLab._forceUpdateRenderData(true);
        if (this.tipsLab.node.width >this.maxNumb) {
            this.tipsLab.node.width = this.maxNumb;
            this.tipsLab.overflow = cc.Label.Overflow.RESIZE_HEIGHT;
            this.tipsLab.horizontalAlign = cc.Label.HorizontalAlign.LEFT;
        }
    }
    ShowStyle(style: number) {
        switch (style) {
            case 1:
                if (this.cancelBtn)
                    this.cancelBtn.active = true;
                if (this.conformBtn)
                    this.conformBtn.setPosition(cc.v2(225.65,this.conformBtn.position.y));
                break;
            case 2:
                if (this.cancelBtn)
                    this.cancelBtn.active = false;
                if (this.conformBtn)
                    this.conformBtn.setPosition(cc.v2(43.43,this.conformBtn.position.y));
        }
    }

    ShowTitleStyle(style : number){

        if (style == 1) {
            
            //提示
            this.titileStyle[0].active = true;
            this.titileStyle[1].active = false;

        }else if(style ==2){
            //错误
            this.titileStyle[0].active = false;
            this.titileStyle[1].active = true;
        }
    }

}